import {HeaderMall9} from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import QRCode from 'qrcode.react';
import BookingOrderDetailContext, {BookingOrderDetailController, useBookingOrderDetailContext} from "../../../../../reducer/moduleReducer/my/bookingOrderDetail";
import {useEffect} from "react";
import {useTranslation,getI18n} from "react-i18next";


function BookingOrderDetailWrap() {
  const { getBookingDetail, getStatus,transformAddress } = BookingOrderDetailController();
  const { state } = useBookingOrderDetailContext();
  const { t } = useTranslation();
  const { detail } = state;
  const reserveInfo = detail.reserveInfo;
  const lang = getI18n().language;
  
  useEffect(() => {
    getBookingDetail();
  }, []);
  
  return (
    <Navigator.container className="container-center">
      {
        reserveInfo &&
        <>
          <div className="relative w-[980px] mx-auto my-0 mdmax:hidden">
            <div className="bg-white flex items-center relative z-10
                        px-[20px] py-[60px] pr-[90px] mt-[50px] mb-[15px] w-[980px]">
              <div className="flex-1">
                <img src={reserveInfo.mainPicView} width="100%"/>
              </div>
              <div className="ml-[40px]">
                <div className="flex-1">
                  <h1 className="text-[18px] mb-[15px] font-bold">{reserveInfo.title}</h1>
                  <p className="text-[14px] mb-[15px]">
                    {t('预约时间')}：{detail.reserveDate} {detail.reserveTime}
                  </p>
                  <p className="text-[14px] mb-[15px]">{t('预约地址')}：{transformAddress(reserveInfo.shopInfo.areaname)}&nbsp;{lang === 'en'?reserveInfo.shopInfo.addressEn:reserveInfo.shopInfo.address}</p>
                  <p className="text-[14px]">{t('预约门店')}：{reserveInfo.shopInfo.shopName}</p>
                </div>
                <div className="border-t border-[#ddd] py-[30px] mt-[30px] flex justify-between">
                  <div className="flex flex-col pr-[90px] justify-between">
                    <div>
                      <p className="mb-[15px]">{t('到店后请出示预约码')}</p>
                      <p className="font-bold text-[18px]">No:{detail.reserveNo}</p>
                    </div>
                    <p className="text-[#999]">
                      {t('下单时间')}：{detail.createTime}
                    </p>
                  </div>
                  <div>
                    <QRCode value={detail.reserveNo}></QRCode>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="md:hidden pb-[20px]">
            <div className="py-[8px] px-[18px] flex items-center">
              <p className="w-[24px] h-[24px] bg-[#666] mr-[8px] rounded-full overflow-hidden">
                <img src={reserveInfo.shopInfo.logoPicView}/>
              </p>
              <p className="">{reserveInfo.shopInfo.shopName}</p>
            </div>
            <div className="py-[12px] px-[18px] flex justify-between items-center bg-[#f8f8f8]">
              <div className="text-[13px]">
                <span>{t('预约时间')}：</span>
                <span className="font-bold">{detail.reserveDate} {detail.reserveTime}</span>
              </div>
              <p className="text-[#E58D40]">{t(getStatus(detail.status))}</p>
            </div>
            
            <div className="py-[12px] px-[18px] flex">
              <div className="overflow-hidden rounded-[10px] flex-none w-[90px] h-[90px] mr-[12px]">
                <img src={reserveInfo.mainPicView} width="100%"/>
              </div>
              <div className="flex-1">
                {/*<p className="mb-[5px]">{t('预约时间')}：{detail.reserveDate} {detail.reserveTime}</p>*/}
                <p className="mb-[5px]">{t('预约项目')}：{reserveInfo.title}</p>
                <p className="mb-[5px]">{t('预约门店')}：{reserveInfo.shopInfo.shopName}</p>
                <p>{t('预约地址')}：{transformAddress(reserveInfo.shopInfo.areaname)}&nbsp;{lang === 'en'?reserveInfo.shopInfo.addressEn:reserveInfo.shopInfo.address}</p>
              </div>
            </div>
            <div className="border-t border-[#eee] mx-[18px] text-center pb-[20px]">
              <p className="pt-[34px] pb-[12px] text-[15px] font-bold">{t('到店后请出示预约码')}</p>
              <div className="inline-block">
                <div className="bg-[#eee] mx-auto rounded-t-[5px] bg-[#f4f4f6] py-[22px] px-[34px]">
                  <QRCode size={130} value={detail.reserveNo}></QRCode>
                </div>
                <p className="relative bg-[#ECBC40] py-[8px] font-bold text-[20px]">
                  <i className="absolute left-[-7px] top-[-7px] w-[14px] h-[14px] rounded-full bg-white inline-block"/>
                  {detail.reserveNo}
                  <i className="absolute right-[-7px] top-[-7px] w-[14px] h-[14px] rounded-full bg-white inline-block"/>
                </p>
              </div>
            </div>
          </div>
        </>
      }
    </Navigator.container>
  );
}

export default function BookingOrderDetail() {
  return (
    <div className="md:bg-[#f4f4f6] md:min-h-[100vh]">
      <HeaderMall9/>
      <Navigator title="预约订单详情" goback/>
      <BookingOrderDetailContext>
        <BookingOrderDetailWrap/>
      </BookingOrderDetailContext>
    </div>
  );
}
